export const checkResponseSuccess = (status) => {
    return [200, 202].includes(status);
};
